import { gql } from '@apollo/client';

export const SIGN_IN_AMCR_MUTATION = gql`
  mutation SignInAmcrMutation($username: String!, $password: String!) {
    signInAmcr(username: $username, password: $password) {
      ... on SignInAmcrSuccess {
        account {
          username
          personId
          personName
          finderNames
          expiresAt
          expired
          findsUrl
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
